function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m84.2 79c-3.2-10.8-4.5-15.9-1.7-25.3 1.6-5.3 2.3-9.1 2-15.3-.4-7.2-3-20.8-3.1-21.4l-7 .7c0 7-3.6 10.6-6.6 12.3-4.8 2.8-11.3 2.8-16.2 0-3-1.7-6.7-5.3-6.7-12.3l-7-.6c-.1.6-2.4 14.8-2.8 21-.4 6 .3 8.5 1.7 13.5l.1.2c.8 2.8 3.1 13.2-.4 27.1l-.5 2 1.5 1.4c3.2 3 19.8 17.5 20.5 18.1l2.3 2 2.3-2c.7-.7 18.3-16 20.5-17.9l1.7-1.5zm-7.4-.2c-3.8 3.4-12.4 10.8-16.5 14.4-4.1-3.6-12.7-11.1-16.5-14.5 2.2-10 2.2-20.5-.1-28.7l-.1-.2c-1.3-4.8-1.8-6.4-1.4-11.1.1-1.7.4-4.1.7-6.7 1.5 1.7 3.2 3.1 5.2 4.3 7.1 4.1 16.2 4 23.2-.1 2.1-1.2 3.9-2.7 5.4-4.5.4 2.6.7 5.2.8 7.1.3 5.2-.3 8.2-1.7 12.9-3.2 10.5-2 16.9 1 27.1z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgUiminen = function SvgUiminen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUiminen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uiminen.969e213d.svg";
export { ForwardRef as ReactComponent };